import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InvoicePreviewOrderLineDetailsService {
  private salesId$ = new BehaviorSubject<{ SalesId: string; ProjId: string }>({
    SalesId: "",
    ProjId: "",
  });
  selectedSalesId$ = this.salesId$.asObservable();

  onSalesIdSelection(event: { SalesId: string; ProjId: string }) {
    this.salesId$.next(event);
  }
}
